<template>
  <div class="col-lg-12 col-xs-12 mt-3 mb-3">
    <div
      class="row border-bottom mb-4 text-capitalize mb-3"
      v-for="talent_bank in talent_banks"
      :key="talent_bank.id"
    >
      <div class="col-lg-1 ml-0">
        <div class="h-100 w-100 d-table">
          <div class="d-table-cell align-middle center">
            <input
              type="checkbox"
              name="selectCandidate"
              :value="checkboxValue(talent_bank)"
              v-model="candidates_selected"
            />
          </div>
        </div>
      </div>
      <div class="col-lg-11 col-xs-12">
        <ItemPreview :talent_bank="talent_bank" />
      </div>

    </div>
  </div>
</template>

<script>
import ItemPreview from "@/Recruiters/TalentBank/Candidates/ItemPreview.vue";
import { formatDistanceStrict, formatDistance, format } from "date-fns";
import { ptBR } from "date-fns/locale";

export default {
  props: ["talent_banks"],
  components: { ItemPreview },
  data: () => ({
    formatDistanceStrict: formatDistanceStrict,
    formatDistance: formatDistance,
    format: format,
    candidates_selected: [],
    showEndWork: false,
    showMoreInfo: false,
    openInfo: "",
    ptBR: ptBR,
  }),
  mounted() {
    eventBus.$on("resetSelected", () => {
      this.candidates_selected = [];
    });
  },
  watch: {
    candidates_selected: function () {
      eventBus.$emit("candidateSelected", this.candidates_selected);
    },
  },
  methods: {
    checkboxValue(talent_bank) {
      return {
        id: talent_bank.candidate_id,
        name: talent_bank.candidate_name,
        email: talent_bank.candidate_email,
        remuneration: talent_bank.remuneration,
      };
    },
  },
};
</script>
